import { z } from 'zod';
/** What made an image, read from the workflow that ran (doc 26). */
export const ImageSettingsSchema = z.object({
    checkpoint: z.string().optional(),
    loras: z.array(z.object({ name: z.string(), strength: z.number().optional() })).default([]),
    seed: z.number().optional(),
    seedNodeId: z.string().optional(),
    steps: z.number().optional(),
    cfg: z.number().optional(),
    sampler: z.string().optional(),
    scheduler: z.string().optional(),
    width: z.number().optional(),
    height: z.number().optional(),
    prompt: z.string().optional(),
    negative: z.string().optional(),
});
export const GalleryImageSchema = z.object({
    id: z.string(),
    runId: z.string().nullable(),
    recipeId: z.string().nullable(),
    recipeTitle: z.string(),
    recipeVersion: z.number().int().nullable(),
    machineId: z.string().nullable(),
    filename: z.string(),
    kind: z.enum(['image', 'video']),
    width: z.number().int().nullable(),
    height: z.number().int().nullable(),
    hasThumb: z.boolean(),
    thumbUrl: z.string(),
    imageUrl: z.string(),
    createdAt: z.string(),
    settings: ImageSettingsSchema,
    /** The original in the archive (doc 76): on its way, there, or the upload failed; null = not archived. */
    archive: z.enum(['pending', 'done', 'failed']).nullable().default(null),
});
/** `space`: preview space used and allowed, in MB (doc 65). */
export const GalleryResponseSchema = z.object({
    images: z.array(GalleryImageSchema),
    nextBefore: z.string().nullable(),
    space: z.object({ usedMb: z.number(), limitMb: z.number() }).optional(),
});
export const GalleryImageResponseSchema = z.object({ image: GalleryImageSchema });
//# sourceMappingURL=gallery.js.map